<template>
  <section>
    <div class="box" style="display: flex; justify-content: space-between;">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click="handleAddChannel">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.platformId" @change="handleSearchChange" placeholder="平台ID" clearable>
            <el-option value="">全部</el-option>
            <el-option v-for="item in platformData" :label="item.platformId + '-' + item.name" :value="item.platformId" :key="item.platformId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.status" @change="handleSearchChange" placeholder="状态" clearable>
            <el-option value="">全部</el-option>
            <el-option v-for="item in statusOption" :label="item.value + '-' + item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <cache-reload reload-type="channel"/>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-select v-model="searchForm.xsType" @change="handleSearchChange" placeholder="XsType" clearable>-->
<!--            <el-option value="">全部</el-option>-->
<!--            <el-option v-for="item in xsTypeOption" :label="item.value + '-' + item.label" :value="item.value" :key="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <div>
        <el-input v-model="search" placeholder="输入关键字搜索（页面）" clearable></el-input>
      </div>
    </div>
<!--    主体内容    -->
    <div class="box">
      <!-- 分页器 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
      <!-- 渠道数据 -->
      <el-table :data="tables" style="width: 100%" stripe :header-cell-style="setTableHeader">
        <el-table-column prop="platformId" label="平台ID" :formatter="platFormFormatter"> </el-table-column>
        <el-table-column prop="id" label="渠道ID" width="100"> </el-table-column>
        <el-table-column prop="name" label="渠道名称">
          <template slot-scope="scope">
<!--            <el-button type="text" @click="handleUpdateChannel(scope.$index, scope.row)">{{scope.row.name}}</el-button>-->
            <el-link type="primary" @click="handleUpdateChannel(scope.$index, scope.row)">{{scope.row.name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="accountChannelId" label="账号渠道ID" width="100"> </el-table-column>
        <el-table-column prop="argsGroupId" label="参数组ID" width="100"> </el-table-column>
        <el-table-column prop="packageType" label="包类型" width="90" :formatter="packageTypeFormatter"></el-table-column>
        <el-table-column prop="channelType" label="ChannelType" width="120" :formatter="channelTypeFormatter"> </el-table-column>
<!--        <el-table-column prop="os" label="os(弃)" width="70"> </el-table-column>-->
        <el-table-column prop="date" label="逻辑参数" width="120">
          <template slot-scope="scope">
            <el-button type="text" class="el-icon-edit-outline" v-if="!scope.row.edit" @click="handleArgsDialog(scope.row.edit, scope.row.argsGroupId)"></el-button>
            <div v-else>
              <el-button type="text" @click="handleArgsDialog(scope.row.edit, scope.row.argsGroupId)" :disabled="scope.row.id!==scope.row.argsGroupId">{{scope.row.logicId}}-{{scope.row.logicName}}</el-button>
            </div>
<!--            <el-button type="text" @click="handleArgsDialog(scope.row.edit, scope.row.argsGroupId)" v-else>{{scope.row.logicName}}</el-button>-->
          </template>
        </el-table-column>
        <el-table-column prop="xsType" label="XsType" width="120">
          <template slot-scope="scope">
            <span v-if="!scope.row.xsType">-</span>
            <div v-else>
              <el-popover placement="bottom" trigger="hover">
                <p>Login: {{scope.row.xsLoginArgsId}} | Pay: {{scope.row.xsPayArgsId}}</p>
                <el-button slot="reference" type="text" size="mini">{{xsTypeFormatter(scope.row, 'xsType', scope.row.xsType)}}</el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>
<!--        <el-table-column prop="xsType" label="XsType" width="120" :formatter="xsTypeFormatter"></el-table-column>-->
<!--        <el-table-column prop="xsLoginArgsId" label="XsLoginArgsId" width="120">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="!scope.row.xsType">-</span>-->
<!--            <div v-else>-->
<!--              <el-button v-if="!scope.row.xsLoginArgsId" type="text" class="el-icon-edit-outline"></el-button>-->
<!--              <el-button v-else type="text" :disabled="scope.row.id!==scope.row.xsLoginArgsId">{{scope.row.xsLoginArgsId}}</el-button>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="xsPayArgsId" label="XsPayArgsId" width="120">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="!scope.row.xsType">-</span>-->
<!--            <div v-else>-->
<!--              <el-button v-if="!scope.row.xsPayArgsId" type="text" class="el-icon-edit-outline"></el-button>-->
<!--              <el-button v-else type="text" :disabled="scope.row.id!==scope.row.xsPayArgsId">{{scope.row.xsPayArgsId}}</el-button>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="customized" label="商品档位" width="100">
          <template slot-scope="scope">
            <el-button round type="text" @click="handleCustomizedDialog(scope.row.edit, scope.row.argsGroupId)" v-show="scope.row.edit" v-if="!scope.row.customized" style="color: #909399">默认</el-button>
            <el-button round type="text" @click="handleCustomizedDialog(scope.row.edit, scope.row.argsGroupId)" v-show="scope.row.edit" v-else >特殊配置</el-button>
          </template>
        </el-table-column>
        <el-table-column label="平台-支付回调" width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.ptCallbackUrl"/>
          </template>
        </el-table-column>
        <el-table-column label="平台-H5登录Url" width="120">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.ptH5LoginUrl" v-if="scope.row.packageType === 3"/>
          </template>
        </el-table-column>
        <el-table-column prop="minAge" label="适龄" width="80"></el-table-column>
        <el-table-column prop="bizId" label="bizId" width="80">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.bizId"/>
          </template>
        </el-table-column>
        <el-table-column prop="realAuthOpen" label="实名" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.realAuthOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="juvenileOpen" label="防沉迷" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.juvenileOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100px" :formatter="autoFormatter"></el-table-column>
        <el-table-column prop="plutoOpen" label="Pluto" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.plutoOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="ufwOpen" label="UFW" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.ufwOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="phoneBindOpen" label="手机号绑定" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.phoneBindOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="loginOpen" label="登录开关" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.loginOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="payOpen" label="支付开关" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.payOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="registerOpen" label="注册开关" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.registerOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="regLimitOpen" label="注册限制" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.regLimitOpen" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="rate" label="折扣率" width="80" :formatter="rateListFormatter"></el-table-column>
        <el-table-column prop="discountType" label="折扣类型" width="100" :formatter="discountTypeFormatter"></el-table-column>
        <el-table-column prop="notifyUrl" label="CP-NotifyUrl" width="110">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.notifyUrl"/>
          </template>
        </el-table-column>
        <el-table-column prop="h5LoginUrl" label="CP-H5Url" width="100">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.h5LoginUrl"/>
          </template>
        </el-table-column>
        <el-table-column prop="gameUrl" label="CP-微端Url" width="100">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.gameUrl"/>
          </template>
        </el-table-column>
        <el-table-column prop="packageName" label="包名" width="100">
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.packageName"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="right" width="60">
          <template slot-scope="scope">
            <el-button type="info" size="mini" @click="handleDeleteChannel(scope.row.id, scope.$index)" icon="el-icon-delete" circle v-show="!scope.row.edit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
<!--    渠道模态框    -->
    <channel-dialog :channelData="channelData" :dialogVisible="dialogVisible" @handleCloseDialog="dialogVisible=false" @handleSaveDialog="handleChannelDialogChange"> </channel-dialog>
<!--    参数配置dialog    -->
    <el-dialog title="参数管理" :visible="argsDialog" @close = "argsDialog = false" top="4vh">
      <el-form :model="argsForm" label-position="right" label-width="80px" :rules="argsRules" ref="argsForm">
        <el-form-item label="参数ID" prop="id" >
          <el-input v-model.number="argsForm.id" :disabled="type"></el-input>
        </el-form-item>
        <el-form-item label="逻辑" prop="logicId">
          <el-select v-model="argsForm.logicId" filterable placeholder="请选择" style="width: 100%;" @change="handleChangeLogicArgs(argsForm.logicId)" clearable>
            <el-option v-for="item in logicData" :key="item[0]" :label="item[0] + '-' + item[1].name + (item[1].status === 1 ? '-废弃' : '')" :value="item[0]">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企微">
          <el-input type="textarea" v-model="argsForm.workWxHtml" active-color="#13ce66" inactive-color="#ff4949" placeholder="关闭注册后，显示的企业微信内容"> </el-input>
        </el-form-item>
        <el-form-item label="参数">
<!--          <div style="margin-top: 8px; margin-right: 15px; display: flex; justify-content: space-between;">-->
<!--            <el-button type="success" size="mini" circle plain icon="el-icon-copy-document" @click="handleValueCopy(argsForm.args)"></el-button>-->
<!--            <el-button type="info" size="mini" circle plain icon="el-icon-view" @click="viewVisible = !viewVisible"></el-button>-->
<!--          </div>-->
<!--          <p v-if="viewVisible">{{ argsForm.args }}</p>-->
          <el-form size="mini" :model="argsForm" label-position="left">
            <el-form-item v-for="(item, i) in argsForm.args" :key="i" :label="item.label" style="margin-top: 20px">
              <el-input v-model="item.value ">{{item}}</el-input>
              <el-checkbox v-model="item.isKeep" v-if="item.show">是否保留(逻辑模板已无此参数,删除可能会造成一些影响，慎重)</el-checkbox>
            </el-form-item>
          </el-form>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex; justify-content: space-evenly;">
        <el-button @click="handleFillArgs()" v-if="type">填充参数</el-button>
        <el-button type="primary" @click="handleSaveArgsDialog()">保 存</el-button>
      </div>
    </el-dialog>
<!--    自定义商品dialog    -->
    <el-dialog title="自定义货币档位" :visible="customizedDialog" @close ="customizedDialog=false" label-position="left" top="4vh">
      <el-form :model="argsForm" label-position="right" label-width="80px" :rules="argsRules" ref="customizedForm">
        <el-form-item label="自定义" prop="customized">
          <el-switch v-model="argsForm.customized" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </el-form-item>
        <!--        货币类型         -->
        <el-form-item label="货币类型" v-show="argsForm.customized">
          <el-select v-model="argsForm.currency" placeholder="请选择" style="width: 100%" filterable @change="currencyChange">
            <el-option v-for="item in options" :key="item.value" :label="item.value + '-' + item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档位" v-show="argsForm.customized">
          <el-form size="mini" :model="customizedForm" >
            <el-form-item style="margin-top: 20px">
              <!--表头-->
              <el-form-item style="float: left;margin-bottom: 5px;width:100%">
                <el-row :gutter="20" style="text-align: left;font-weight: bold">
                  <el-col :span="3"><span>商品ID</span></el-col>
                  <el-col :span="3"><span>价格(分)</span></el-col>
                  <el-col :span="5"><span>商品名称</span></el-col>
                  <el-col :span="5"><span>商品描述</span></el-col>
                  <el-col :span="5"><span>渠道商品ID</span></el-col>
                  <el-col :span="3"><span>操作</span></el-col>
                </el-row>
              </el-form-item>
              <!--参数-->
              <el-form-item v-for="(item, i) in customizedForm.products" :key="i" style="float: left;margin-bottom: 5px;width:100%">
                <el-row :gutter="20">
                  <el-col :span="3"><el-input v-model="item.id" placeholder="商品ID" :disabled="item.disabled"> </el-input></el-col>
                  <el-col :span="3"><el-input v-model="item.price" placeholder="价格(分)" :disabled="item.disabled"> </el-input></el-col>
                  <el-col :span="5"><el-input v-model="item.name" placeholder="商品名称"> </el-input></el-col>
                  <el-col :span="5"><el-input v-model="item.desc" placeholder="商品描述"> </el-input></el-col>
                  <el-col :span="5"><el-input v-model="item.cid" placeholder="渠道商品ID"> </el-input></el-col>
                  <el-col :span="3"><el-button type="info" size="mini" circle icon="el-icon-delete" @click="handleDeleteProductsParams(i)" :disabled="item.disabled"> </el-button></el-col>
                </el-row>
              </el-form-item>
              <el-form-item v-if="formatJson">
                <el-input type="textarea" placeholder="请输入内容" v-model="textarea"> </el-input>
                <el-button type="primary" size="mini" @click="handleFormatJson">自动转换</el-button>
              </el-form-item>
              <el-form-item style='float: left; display: flex; align-items: center;'>
                <el-button type="primary" size="mini" @click="handleAddProductsParams()" style='margin-right: 10px;'>添加</el-button>
                <el-button type="primary" size="mini" @click="handleAddTextarea" style='margin-right: 10px;'>粘贴文本</el-button>
                <el-upload action="" :auto-upload="false" :show-file-list="false" accept=".xlsx,.xls,.csv" :on-change="handleAddFile" style='display: inline-block;'>
                  <el-button type="primary" size="mini">
                    文件上传
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-form-item>
          </el-form>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="handleSaveArgsDialog">保 存</el-button>
      </div>
    </el-dialog>
<!--    <args-dialog :formData="argsForm" :dialogVisible.sync="xArgsDialog" @handleSaveDialog="handleXArgsDialogChange" @handleCloseDialog="xArgsDialog=false"></args-dialog>-->
  </section>
</template>

<script>
import ChannelDialog from './ChannelDialog'
import api from '@/api/channel'
import options from '@/common/options'
import f from '@/filter'
import CacheReload from '@/components/CacheReload/index.vue'
import ExtTextPopover from '@/components/ExtTextPopover/index.vue'

export default {
  name: 'index',
  components: { CacheReload, ChannelDialog, ExtTextPopover },
  created () {
    this.$store.dispatch('GetChannelTypeList').then((res) => {
      this.channelTypeList = res
    })
    this.fetchData(this.pageSize, this.currentPage)
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    appInfo () {
      return this.$store.getters.appInfo
    },
    tables () {
      const search = this.search
      if (search) {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search) > -1
          })
        })
      }
      return this.tableData
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData(this.pageSize, this.currentPage)
    }
  },
  data () {
    return {
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      channelData: {},
      argsData: new Map(),
      searchForm: {
        platformId: '',
        status: '',
        xsType: ''
      },
      search: '',
      argsForm: {
        currency: 'CNY',
        products: []
      },
      viewVisible: false,
      type: false, // 默认状态为新增  true 为修改 false为新增
      logicData: new Map(),
      platformData: [],
      dialogVisible: false,
      argsDialog: false,
      // xArgsDialog: false,
      customizedDialog: false,
      customizedForm: {
        products: [{ id: '', name: '', price: 0, desc: '', cid: '' }]
      },
      options: options.currency,
      statusOption: options.statusOption,
      xsTypeOption: options.xsTypeOption,
      argsRules: {
        id: { type: 'number', required: true, message: '请输入id，且不能为空', trigger: 'change' },
        logicId: { type: 'number', required: true, message: '请输入logicId，且不能为空', trigger: 'change' },
        status: { type: 'boolean', required: true, message: '请选择状态', trigger: 'change' },
        customized: { type: 'boolean', required: true, message: '请选择状态', trigger: 'change' }
      },
      textarea: '',
      formatJson: false,
      // gatewayUrl: '',
      channelTypeList: [],
      areaMap: new Map()
    }
  },
  methods: {
    fetchData (pageSize, currentPage) {
      const params = Object.assign({}, this.searchForm, {
        size: pageSize,
        page: currentPage,
        appId: this.appId
      })
      api.getAreas().then(res => {
        this.areaMap = this.mapData(res)
      })
      api.getPlatformData(this.appId).then(res => {
        this.platformData = res
      })
      api.getLogicData().then(res => {
        this.logicData = this.mapData(res)
      })
      api.getArgsList(this.appId).then(res => {
        this.argsData = this.mapData(res)
        api.getChannelDataByPage(params).then(res => {
          const list = res.data
          this.totalCount = res.total
          for (const item of list) {
            // true 是修改  false 是新增
            item.edit = this.argsData.has(item.argsGroupId)
            if (item.edit) {
              item.customized = this.argsData.get(item.argsGroupId).customized
              const logicId = this.argsData.get(item.argsGroupId).logicId
              item.logicId = logicId
              const logic = this.logicData.get(logicId)
              item.logicName = logic.name + (logic.status === 1 ? '-废弃' : '')
            }
            item.ptH5LoginUrl = this.getPtH5LoginUrl(item)
            item.ptCallbackUrl = this.getPtCallback(item)
          }
          this.tableData = list
        })
      })
    },
    handleSearchChange (val) {
      this.currentPage = 1
      this.fetchData(this.pageSize, this.currentPage)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData(val, this.currentPage)
    },
    // 显示第几页
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData(this.pageSize, val)
    },
    // 新增渠道
    handleAddChannel () {
      const id = this.tableData.length ? this.tableData[this.tableData.length - 1].id : 0
      this.channelData = { id: id + 1, accountChannelId: id + 1, argsGroupId: id + 1, os: '', status: 0, areaId: 0, discountType: 0 }
      this.dialogVisible = true
    },
    // 修改渠道
    handleUpdateChannel (index, rowData) {
      this.channelData = Object.assign({}, rowData)
      this.dialogVisible = true
    },
    // 渠道 删除
    handleDeleteChannel (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteChannel(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    // 关闭渠道模态框
    handleChannelDialogChange (value) {
      this.dialogVisible = value
      this.fetchData(this.pageSize, this.currentPage)
    },
    // 打开参数dialog
    handleArgsDialog (edit, argsGroupId) {
      this.argsDialog = true
      this.type = !!edit
      // edit true 修改 false 新增
      if (!edit) {
        this.argsForm = {
          id: argsGroupId,
          currency: 'CNY',
          workWxHtml: '',
          args: [],
          products: null
        }
      } else {
        this.fetchArgsData(argsGroupId)
      }
    },
    // 获取参数数据
    fetchArgsData (argsGroupId) {
      api.getArgs(argsGroupId).then(res => {
        const data = Object.assign({}, res)
        data.args = JSON.parse(data.args)
        for (const item of this.logicData) {
          if (item[0] === data.logicId) {
            data.args = this.mapLogic(JSON.parse(item[1].args), data.args)
          }
        }
        // 以下为product 的操作
        const products = new Map() // 最终结果
        // 来自游戏的档位参数
        const appProductData = JSON.parse(this.appInfo.products)
        const appMap = new Map()
        if (appProductData) {
          for (const item of appProductData) {
            appMap.set(item.id, item)
          }
        }
        // 来自服务器的自定义档位参数
        const customizedProductData = data.products ? JSON.parse(data.products) : []
        const customizedSet = new Set()
        if (customizedProductData.length) {
          for (const item of customizedProductData) {
            // 来自服务器数据全部可修改
            item.disabled = false
            customizedSet.add(item.id)
            products.set(item.id, item)
            if (appMap.has(item.id)) {
              item.disabled = true
            }
          }
        }
        // 来自游戏的数据与游戏的数据做比对，将来自游戏的档位状态改为不可修改
        for (const key of appMap.keys()) {
          if (!customizedSet.has(key)) {
            const data = appMap.get(key)
            data.disabled = true
            data.cid = ''
            products.set(key, data)
          }
        }
        const productArr = []
        for (const item of products) {
          productArr.push(item[1])
        }
        // 对比完成之后的货币档位参数存放在其他的地方
        this.customizedForm.products = productArr
        this.argsForm = data
      })
    },
    // 当参数模板的逻辑ID改变时
    handleChangeLogicArgs (id) {
      let data = []
      for (const item of this.logicData) {
        if (item[0] === id) {
          data = JSON.parse(item[1].args)
          this.argsForm.args = data
        }
      }
    },
    // 填充参数
    handleFillArgs () {
      const args = this.logicData.get(this.argsForm.logicId).args
      const logicTemplate = args ? JSON.parse(args) : null
      const logicTemplateMap = new Map()
      for (const item of logicTemplate) {
        logicTemplateMap.set(item.key, item)
      }
      if (logicTemplate) {
        for (const item of this.argsForm.args) {
          if (!item.value) {
            item.value = logicTemplateMap.get(item.key).value
          }
        }
      }
    },
    handleValueCopy (value) {
      navigator.clipboard.writeText(value).then(() => {
        this.$message.success('复制成功')
      })
    },
    // 保存或修改参数
    handleSaveArgsDialog () {
      const params = Object.assign({}, this.argsForm)

      // 检查args参数中是否包含空格
      const argsWithSpaces = []
      for (const item of params.args || []) {
        if (item.value && typeof item.value === 'string' && item.value.includes(' ')) {
          argsWithSpaces.push(`${item.label || item.key}: "${item.value}"`)
        }
      }

      // 如果检测到空格，显示确认对话框
      if (argsWithSpaces.length > 0) {
        const message = `检测到以下参数含有空格：\n${argsWithSpaces.join('\n')}\n\n参数含空格，请确认是否继续保存？`
        this.$confirm(message, '参数空格提醒', {
          confirmButtonText: '确定保存',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'space-warning-dialog'
        }).then(() => {
          this.doSaveArgs(params)
        }).catch(() => {
          this.$message.info('已取消保存')
        })
      } else {
        this.doSaveArgs(params)
      }
    },

    // 执行实际的保存操作
    doSaveArgs (params) {
      // 先处理product 去除里面的空值以及每个属性的disable
      if (this.customizedForm.products.length > 0) {
        let len = this.customizedForm.products.length
        const arr = this.customizedForm.products
        while (len--) {
          delete arr[len].disabled
          if (arr[len].id === '') {
            arr.splice(len, 1)
          }
        }
      }
      if (params.customized) {
        params.products = this.customizedForm.products.length > 0 ? JSON.stringify(this.customizedForm.products) : null
      }
      const args = {}
      // item.hasOwnProperty('isKeep')
      for (const item of params.args) {
        args[item.key] = item.value
        if (Object.prototype.hasOwnProperty.call(item, 'isKeep') && !item.isKeep) {
          delete args[item.key]
        }
      }
      params.args = JSON.stringify(args)
      const f = this.type ? api.changeArgs : api.addArgs
      f(params).then(() => {
        this.$message.success(this.type ? '修改成功' : '添加成功')
        this.fetchData(this.pageSize, this.currentPage)
        // this.$store.dispatch('GetApp').then(() => {})
        this.argsDialog = false
        this.customizedDialog = false
        this.$refs.argsForm.clearValidate()
        this.$refs.customizedForm.clearValidate()
      })
    },
    // 打开自定义货币dialog
    handleCustomizedDialog (edit, argsGroupId) {
      this.type = !edit
      this.fetchArgsData(argsGroupId)
      this.customizedDialog = true
    },
    // 添加货币档位参数
    handleAddProductsParams () {
      let params = {}
      params = { id: '', name: '', price: 0, desc: '', cid: '', disabled: false }
      if (!this.customizedForm.products) {
        this.customizedForm.products = []
      }
      this.customizedForm.products.push(params)
    },
    // 打开文本输入
    handleAddTextarea () {
      this.formatJson = !this.formatJson
    },
    // 文件导入
    handleAddFile (uploadFile) {
      if (!uploadFile || !uploadFile.raw) {
        return this.$message.warning('请选择文件')
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = e.target.result
          const XLSX = require('xlsx')
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]

          const excelData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['id', 'price', 'name', 'desc', 'cid'], range: 1
          })
          if (excelData.length === 0) {
            return this.$message.warning('Excel文件中没有数据')
          }

          excelData.forEach(row => {
            if (row.id !== undefined && row.id !== null) {
              row.id = String(row.id).trim()
            }
            if (row.price !== undefined && row.price !== null) {
              row.price = Number(row.price)
            }
          })

          const products = this.customizedForm.products || []
          const oldMap = new Map(products.map(item => [item.id, item]))
          for (const newItem of excelData) {
            if (oldMap.has(newItem.id)) {
              Object.assign(oldMap.get(newItem.id), newItem)
            } else {
              oldMap.set(newItem.id, newItem)
            }
          }
          console.log(oldMap)

          this.customizedForm.products = Array.from(oldMap.values())
          this.$message.success('导入成功')
        } catch (error) {
          console.error('解析Excel文件失败:', error)
        }
      }
      reader.onerror = () => {
        this.$message.error('读取文件失败')
      }
      reader.readAsArrayBuffer(uploadFile.raw)
    },
    // 删除货币档位参数
    handleDeleteProductsParams (i) {
      this.customizedForm.products.splice(i, 1)
    },
    // 改变货币种类时
    currencyChange () {
      // 发送请求，并修改参数模板
      const params = { appId: this.appId, currency: this.argsForm.currency }
      // 请求货币接口
      api.getCurrencyData(params).then(res => {
        const data = Object.assign({}, res)
        if (data.products) {
          this.customizedForm.products = JSON.parse(data.products)
        }
      })
    },
    autoFormatter (row, column, cellValue) {
      return f.autoFormat(column.property, cellValue)
    },
    getArea (areaId) {
      const id = areaId || this.appInfo.areaId
      return this.areaMap.get(id) || {}
    },
    // 生成ptCallback
    getPtCallback (row) {
      const logicId = row.logicId
      if (!logicId) {
        return null
      }
      const area = this.getArea(row.areaId)
      return area.callbackUrl + `/callback/c${logicId}/${row.id}`
    },
    // 生成ptH5loginURL
    getPtH5LoginUrl (row) {
      const logicId = row.logicId
      if (!logicId) {
        return null
      }
      const area = this.getArea(row.areaId)
      return area.gatewayUrl + `/h5/login/c${logicId}/${row.id}`
    },
    // handleXArgsDialogChange (value) {
    //   // value可能接收的是一个布尔值，也有可能接收的是一个对象
    //   if (typeof value === 'object') {
    //     this.xArgsDialog = false
    //     this.fetchData(this.pageSize, this.currentPage)
    //   } else {
    //     this.xArgsDialog = value
    //   }
    // },
    // handleUpdateXArgsData (index, argsGroupId, type) {
    //   this.argsForm = {
    //     type: type,
    //     argsGroupId: argsGroupId
    //   }
    //   this.xArgsDialog = true
    // },
    platFormFormatter (row, column, cellValue) {
      for (const item of this.platformData) {
        if (item.platformId === cellValue) {
          return item.platformId + '-' + item.name
        }
      }
      return cellValue
    },
    packageTypeFormatter (row, column, cellValue) {
      return f.packageTypesFormat(cellValue)
    },
    rateListFormatter (row, column, cellValue) {
      return f.rateFormat(cellValue)
    },
    discountTypeFormatter (row, column, cellValue) {
      return f.discountTypeFormat(cellValue)
    },
    xsTypeFormatter (row, column, cellValue) {
      return f.xsTypeFormat(cellValue)
    },
    channelTypeFormatter (row) {
      const channelType = row.channelType
      const item = this.channelTypeList.find(item => item.id === channelType)
      if (item) {
        return item.id + '-' + item.name
      }
      return channelType
    },
    mapData (value) {
      const data = new Map()
      for (const item of value) {
        data.set(item.id, item)
      }
      return data
    },
    mapLogic (arr, obj) {
      //  obj是服务器拿下来的 arr是模板
      const arrMap = new Map()
      for (const item of arr) {
        arrMap.set(item.key, item)
        item.value = obj[item.key]
      }
      for (const item in obj) {
        if (!arrMap.has(item)) {
          arr.push({ key: item, value: obj[item], label: item, isKeep: true, show: true })
        }
      }
      return arr
    },
    setTableHeader () {
      return 'color: #000'
    },
    // 格式转换
    handleFormatJson () {
      if (!this.textarea) {
        return this.$message.info('请输入内容')
      }
      if (typeof this.textarea !== 'string') {
        return this.$message.info('请输入字符串类型')
      }
      if (this.isJsonString(this.textarea)) {
        this.products = JSON.parse(this.textarea)
      } else {
        return this.$message.info('请输入正确格式')
      }
    },
    isJsonString (str) {
      try {
        if (typeof JSON.parse(str) === 'object') {
          return true
        }
      } catch (e) {
      }
      return false
    }
  }
}
</script>

<style scoped>
/* 空格警告对话框样式 */
::v-deep .space-warning-dialog .el-message-box__message {
  white-space: pre-line;
  line-height: 1.5;
}
</style>
